import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Image, Spinner } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../SignUp/onBoarding/education.css";

import edu from "../../../../../assets/images/education.png";

import { showAlert } from "../../../../../utils/alertUtils";
import { useCookies } from "../../../../../hooks/useCookies";
import Sidebar from "../../../../userflow/components/sidebar/sidebar";
import { useProfile } from "../../../../userflow/components/context/ProfileContext";

import * as userActions from "../../../../../actions/user";
import * as masterConstantActions from "../../../../../actions/masterConstant";

export const EducationUpdate = () => {
  const navigate = useNavigate();
  const { getCookie } = useCookies();
  const approvalstatus = getCookie("approval");
  const { updateProfile } = useProfile();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessege] = useState("");
  const [studiesList, setStudiesList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    let isMounted = true;

    (async () => {
      try {
        const [studiesResponse, userStudiesResponse] = await Promise.all([
          masterConstantActions.getConstantStudies(),
          userActions.getUserStudies(),
        ]);

        if (isMounted) {
          if (studiesResponse.status && studiesResponse.data.length > 0) {
            setStudiesList(studiesResponse.data);
          }
          setSelectedOption(userStudiesResponse?.studies?.[0]?.id || null);
        }
      } catch (error) {
        console.error("Error fetching education data:", error);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  const goTojobTitle = async () => {
    await updateProfile("update");
    if (approvalstatus === "PENDING") {
      showAlert(
        "Success",
        "Approval request sent!",
        () => (window.location.href = "/user/home")
      );
    } else {
      showAlert(
        "Success",
        "Successfully updated",
        () => (window.location.href = "/user/home")
      );
    }
  };

  const saveEducation = async () => {
    if (!selectedOption) {
      setErrorMessege("*Please make a selection.");
      return;
    }

    setLoading(true);
    try {
      await userActions.UpdateUserStudies({ id: selectedOption });
      goTojobTitle();
    } catch (error) {
      setErrorMessege("*An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Sidebar>
      <div
        style={{
          flex: "1",
          marginInline: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",
          scrollbarWidth: "none",
          padding: "2rem",
        }}
      >
        <div className="education-container" style={{ overflow: "hidden" }}>
          <Container className="education-main">
            <Container className="education-content">
              <Container className="education-details">
                <div className="your-education">
                  <Container className="education-text">
                    <Image
                      className="about-yourself-icon"
                      src={edu}
                      alt="Education Icon"
                    />
                    <p>What’s the highest level you’ve attained?</p>
                  </Container>
                  <Container className="all-education">
                    <div className="row mt-3">
                      {studiesList.map((study) => (
                        <div
                          key={study.id}
                          onClick={() => setSelectedOption(study.id)}
                          className="col-6 sub-inner-div"
                          style={{
                            backgroundColor:
                              selectedOption === study.id
                                ? "#F7ECFF"
                                : "transparent",
                            marginRight: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          {study.name}
                        </div>
                      ))}
                    </div>
                    {errorMessage && (
                      <p
                        className="text-danger error-message"
                        style={{
                          marginLeft: "10px",
                          marginTop: "-10px",
                        }}
                      >
                        {errorMessage}
                      </p>
                    )}
                  </Container>
                </div>
              </Container>
              <div
                className="d-flex justify-content-center"
                style={{
                  position: "fixed",
                  bottom: "30px",
                  width: "100%",
                  gap: "30px",
                }}
              >
                <button
                  className="global-cancel-button"
                  onClick={() => navigate("/updateprofile")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="global-save-button"
                  onClick={saveEducation}
                >
                  {loading ? (
                    <Spinner animation="border" size="sm" role="status" />
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </Container>
          </Container>
        </div>
      </div>
    </Sidebar>
  );
};
